import { Link } from 'react-router-dom';
import { useLang } from '../../../i18n/LanguageContext';
import { commonDict } from '../../../i18n/dictionaries/common';
import styles from './SiteFooter.module.css';

type SiteFooterProps = {
  /** Render a top border (used on inner pages). */
  readonly bordered?: boolean;
};

export const SiteFooter = ({
  bordered = false,
}: SiteFooterProps): JSX.Element => {
  const { lang } = useLang();
  const t = commonDict[lang].footer;

  const className = bordered
    ? `${styles.footer} ${styles.bordered}`
    : styles.footer;

  return (
    <footer id="footer" className={className}>
      <div className={styles.footerInner}>
        <div className={styles.footerLinks}>
          <Link to="/privacy" className={styles.footerLink}>
            {t.privacy}
          </Link>
          <a href="mailto:lisong@cji.jp" className={styles.footerLink}>
            {t.contact}
          </a>
        </div>
        <p className={styles.footerCopyright}>@CJI, All rights reserved.</p>
      </div>
    </footer>
  );
};
